/* EVANTO product page — gallery, variants, bundles, quantity, sticky bar */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function cartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-ev-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
      }).catch(function () {});
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var img = $('.ev-gallery__main img', root);
    var thumbs = $$('[data-ev-thumb]', root);
    if (!thumbs.length) return null;
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = thumbs[idx].dataset.full; img.alt = thumbs[idx].dataset.alt || ''; }
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = $('[data-ev-prev]', root), next = $('[data-ev-next]', root);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    return {
      showMedia: function (id) {
        for (var i = 0; i < thumbs.length; i++) if (thumbs[i].dataset.mediaId === String(id)) { show(i); return; }
      }
    };
  }

  /* ---------- product form ---------- */
  var state = null;
  var stickyListener = null;
  function emit() { if (stickyListener) stickyListener(state); }

  function initProduct(root) {
    var dataEl = $('[data-ev-variants]', root);
    var form = $('form.ev-form', root);
    if (!dataEl || !form) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[name=id]', form), qtyInput = $('[name=quantity]', form);
    var btn = $('[data-ev-atc]', root);
    var sets = $$('[data-ev-option]', root);
    var gallery = initGallery(root);

    function selected() { return sets.map(function (s) { var c = $('input:checked', s); return c ? c.value : null; }); }
    function find(opts) {
      if (!sets.length) return variants[0];
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function bundle() {
      var r = $('input[name=ev_bundle]:checked', root);
      if (!r) return null;
      return { id: r.closest('[data-ev-bundle]').dataset.bundleId, qty: parseInt(r.value, 10) || 1, label: r.dataset.label };
    }
    function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt || ''; }); }

    function render(fromUser) {
      var opts = selected(), v = find(opts), b = bundle();
      sets.forEach(function (s) { var c = $('input:checked', s), l = $('[data-ev-option-label]', s); if (c && l) l.textContent = c.value; });
      $$('[data-ev-bundle]', root).forEach(function (el) { el.classList.toggle('is-selected', $('input', el).checked); });
      var label = btn ? btn.dataset.label : '';
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; }
        return;
      }
      idInput.value = v.id;
      qtyInput.value = b ? b.qty : (parseInt(qtyInput.value, 10) || 1);
      setText('[data-ev-price]', v.price_fmt);
      setText('[data-ev-compare]', v.compare_fmt);
      setText('[data-ev-save]', v.save ? 'Save ' + v.save + '%' : '');
      $$('[data-ev-bundle]', root).forEach(function (el) {
        var d = v.bundles[el.dataset.bundleId]; if (!d) return;
        $('[data-ev-bundle-price]', el).textContent = d.p;
        $('[data-ev-bundle-compare]', el).textContent = d.c;
      });
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (label + (v.save ? ' — Save ' + v.save + '%' : '')) : btn.dataset.soldout;
      }
      var bd = b && v.bundles[b.id];
      state = {
        title: v.title + (b && b.label ? ' · ' + b.label : ''),
        price: bd ? bd.p : v.price_fmt, compare: bd ? bd.c : v.compare_fmt,
        image: v.image_url, available: v.available, label: btn ? btn.textContent : ''
      };
      if (fromUser && v.media && gallery) gallery.showMedia(v.media);
      emit();
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-ev-option] input')) render(true);
      else if (e.target.matches('input[name=ev_bundle]')) render(false);
    });
    var minus = $('[data-ev-minus]', root), plus = $('[data-ev-plus]', root), qd = $('[data-ev-qty-display]', root);
    function setQty(n) { n = Math.max(1, n || 1); qtyInput.value = n; if (qd) qd.value = n; }
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qd) qd.addEventListener('change', function () { setQty(parseInt(qd.value, 10)); });

    /* ---- Add to cart (AJAX, with native-submit fallback) ----
       Reads the whole form with FormData, so any field a bundle app adds
       inside the form (properties[...], selling_plan, etc.) is sent too. */
    var adding = false;
    var errBox = document.createElement('p');
    errBox.setAttribute('role', 'alert');
    errBox.style.cssText = 'color:#b3261e;font-size:14px;margin:10px 0 0;display:none';
    var actions = $('.ev-actions', form);
    if (actions) actions.parentNode.insertBefore(errBox, actions.nextSibling);
    function showErr(msg) { errBox.textContent = msg || ''; errBox.style.display = msg ? 'block' : 'none'; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (adding) return;
      if (!idInput.value || idInput.value === '0') { showErr('Please select an option first.'); return; }
      showErr('');
      adding = true;
      var allBtns = $$('[data-ev-atc], [data-ev-sticky-btn]');
      var oldTxt = allBtns.map(function (b) { return b.textContent; });
      allBtns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) throw { shopify: true, msg: res.j.description || res.j.message || 'Could not add to cart.' };
        allBtns.forEach(function (b) { b.textContent = 'Added ✓'; });
        cartCount();
        setTimeout(function () { window.location.href = root + 'cart'; }, 350);
      }).catch(function (err) {
        adding = false;
        allBtns.forEach(function (b, i) { b.disabled = false; b.textContent = oldTxt[i]; });
        if (err && err.shopify) { showErr(err.msg); render(false); }
        else { form.submit(); } /* network/JSON problem: fall back to normal form post */
      });
    });
    render(false);
  }

  /* ---------- sticky bar ---------- */
  function initSticky(bar) {
    var title = $('[data-ev-sticky-title]', bar), price = $('[data-ev-sticky-price]', bar),
        was = $('[data-ev-sticky-compare]', bar), btn = $('[data-ev-sticky-btn]', bar), thumb = $('[data-ev-sticky-thumb]', bar);
    stickyListener = function (s) {
      if (!s) return;
      if (title) title.textContent = s.title;
      if (price) price.textContent = s.price;
      if (was) was.textContent = s.compare || '';
      if (btn) { btn.textContent = s.label; btn.disabled = !s.available; }
      if (thumb && s.image) { thumb.src = s.image; thumb.hidden = false; }
    };
    if (state) stickyListener(state);
    var anchor = $('[data-ev-atc]');
    if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting); }, { threshold: 0 }).observe(anchor);
  }

  function init() {
    cartCount();
    var bar = $('[data-ev-sticky]');
    if (bar) initSticky(bar);
    var main = $('[data-ev-product]');
    if (main) initProduct(main);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
